export default __webpack_public_path__ + "8653b775c9b3da21e7e51228af65b6d7.svg";